import React, { useContext, useState, useEffect } from 'react';
import { Table, Button, InputPicker, Whisper, Tooltip } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../utils/i18n';
import { ReportsService } from '../../../services';
import { UserContext, ToasterContext } from '../../../context';
import { ReactComponent as EditIcon } from '../../../assets/svg/edit.svg';
import { ReactComponent as SaveIcon } from '../../../assets/svg/save.svg';
import { ReactComponent as KebabIcon } from '../../../assets/svg/kebab.svg';
import './report-metrics.scss';
import RightModal from '../../atoms/right-modal/right-modal';
import CustomMetric from '../custom-metric/custom-metric';
import { useDrag, useDrop, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/trash-outline.svg';
import {
  ModalWindow,
  ActionLink,
  SelectedCampaignsContainer,
  CommonToaster,
  AppTooltip,
} from '../../atoms';
import { useHistory } from 'react-router-dom';
import { Checkbox, Radio } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const ReportMetrics = ({
  activeStep,
  setActiveStep,
  stepperData,
  setStepperData,
  draftReportId,
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [openSliderModal, setOpenSliderModal] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [performanceMetrics, setPerformanceMetrics] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [selectedMetris, setSelectedMetrics] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [selectedCurrency, setSelecedCurrency] = useState('');
  const [selectedCurLabel, setCurrencyLabel] = useState({});
  const { Column, HeaderCell, Cell } = Table;
  const [currentEditCusMetric, setCurrentEditCusMetric] = useState({});
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const [popularMetricsList, setPopularMetricsList] = useState([]);
  const [originalPopularList, setOriginalPopularList] = useState([]);
  const [existingData, setExistingData] = useState({});
  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);
  const [showDeleteAttributeModal, setShowDeleteAttributeModal] = useState(false);
  const [delAttr, setDelAttr] = useState({});
  const [sysMetrics, setSysMetrics] = useState([]);
  const [expand, setExpand] = useState(false);
  const [isCustomMetricAdded, setIsCustomMetricAdded] = useState(false);
  const [perfMetricsWithSub, setPerfMetricsWithSub] = useState([]);
  const reportId = draftReportId ? draftReportId : stepperData?.data?.data?.reportId;
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;

  const ItemTypes = {
    COLUMN: 'column',
    ROW: 'row',
  };
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    getPerformanceMetrics();
    removeSearchedKey();
    if (draftReportId && user?.isSaveDraft) {
      let msg = t('mgs.success.saveStep');
      setTheMessages({ message: msg, isError: false });
    }
  }, []);

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });

  async function getPerformanceMetrics() {
    try {
      const perfMetrics = await ReportsService.getKpiMetrics(userAccessToken, username);
      let perfList = perfMetrics.data?.data;
      perfList.forEach(data => {
        data.isChecked = false;
        data.isEdit = false;
      });
      getCurrencyData([...perfList]);
      setSysMetrics([...perfList]);
      // setPerformanceMetrics([...perfList]);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  async function getCurrencyData(perfList) {
    try {
      const currencyDetails = await ReportsService.getCurrencyDetails(userAccessToken, username);
      const curDetails = currencyDetails?.data?.data?.map(cur => ({
        label: cur.currency,
        value: cur.conversionRate
      }));
      getReportResponse(perfList, curDetails);
      setCurrencyData([...curDetails]);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  async function getPopularMetrics(list, advert) {
    try {
      const adv = stepperData?.config?.data ? JSON?.parse(stepperData?.config?.data) : advert;
      const popularMetrics = await ReportsService.getPopularMetrics(
        userAccessToken,
        username,
        adv?.advertiser
      );
      const response = popularMetrics?.data?.data;
      let popularResult = [];
      response?.forEach(li => {
        list?.forEach(res => {
          if (li?.sys_id?.trim() === res?.sys_id?.trim()) {
            popularResult.push(res);
          }
        });
      });
      setPopularMetricsList([...popularResult]);
      setOriginalPopularList([...popularResult]);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }

    }
  }

  async function getReportResponse(perfList, curDetails) {
    try {
      const reportRes = await ReportsService.getReportDetails(userAccessToken, username, reportId);
      let resultedReportResponse = reportRes?.data?.data;
      resultedReportResponse.metrics.forEach(val => {
        perfList.forEach(data => {
          if (val.sys_id === data.sys_id) {
            data.isChecked = true;
            data.planned_value = val?.plannedValue;
            data.primary_kpi = val?.isPrimaryKpi;
            data.secondary_kpi = val?.isSecondaryKpi;
          }
        });
      });
      let index = curDetails?.findIndex(cur => cur?.label === resultedReportResponse?.currency);
      if (index > -1) {
        setSelecedCurrency(curDetails[index]?.value);
        setCurrencyLabel(curDetails[index]);
      }
      setTheCheckedValues(perfList, true, resultedReportResponse);
      setExistingData({ ...resultedReportResponse });
      setUser(prevUser => ({
        ...user,
        selectedAdvertiser: resultedReportResponse?.advertiser,
        selectedAdaccounts: resultedReportResponse?.campaigns[0]?.accountId,
        reportName: resultedReportResponse?.reportName,
        reportType: resultedReportResponse?.type
      }));
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  async function getCustomMetrics(perfList, isNewlyAdded, existResponse) {
    try {
      const adv = stepperData?.config?.data
        ? JSON?.parse(stepperData?.config?.data)
        : existResponse;
      const cusMetricData = await ReportsService.getCustomDetails(
        userAccessToken,
        username,
        reportId,
        adv?.advertiser
      );
      let responseDetails = cusMetricData?.data?.data;
      responseDetails.forEach(res => {
        res.type = 'custom';
        res.KPI_subcategory = 'Custom Metrics';
      });
      if (isNewlyAdded) {
        const upadtedRes = [...perfList, responseDetails[responseDetails?.length - 1]];
        const newVal = getUniqueListBy(upadtedRes, 'sys_id');
        setPerformanceMetrics([...newVal]);
        setOriginalList([...newVal]);
      } else {
        let allRes = [...perfList, ...responseDetails];
        existResponse.metrics.forEach(val => {
          allRes.forEach(data => {
            if (val.sys_id === data.sys_id) {
              data.isChecked = true;
              data.planned_value = val?.plannedValue;
              data.primary_kpi = val?.isPrimaryKpi;
              data.secondary_kpi = val?.isSecondaryKpi;
              data.order = val?.order;
            }
          });
        });
        setTheCustomCheckedVal([...allRes]);
        getPopularMetrics([...allRes], adv);
        setPerformanceMetrics([...allRes]);
        setOriginalList([...allRes]);
      }
    } catch (error) {
      setPerformanceMetrics([...perfList]);
      setOriginalList([...perfList]);
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  const setTheCustomCheckedVal = perfList => {
    let reportData = [];
    perfList.forEach(metric => {
      if (metric.isChecked) {
        reportData.push({
          sys_id: metric.sys_id,
          metric_name: metric.KPI_Metric ? metric.KPI_Metric : metric?.name,
          planned_value: metric.planned_value ? metric.planned_value : '',
          primary_kpi: metric.primary_kpi ? metric.primary_kpi : false,
          secondary_kpi: metric.secondary_kpi ? metric.secondary_kpi : false,
          data_type: metric?.data_type,
          type: metric?.type,
          order: metric?.order,
          can_be_secondary: metric?.can_be_secondary,
          can_be_primary: metric?.can_be_primary,
        });
      } else {
        metric.primary_kpi = false;
        metric.secondary_kpi = false;
      }
    });
    reportData.forEach(li => {
      originalList.forEach(res => {
        if (li.sys_id === res.sys_id) {
          res.isChecked = true;
          res.planned_value = li?.planned_value;
          res.primary_kpi = li?.primary_kpi;
          res.secondary_kpi = li?.secondary_kpi;
        }
      });
    });
    reportData.sort((a, b) => a?.order - b?.order);
    setOriginalList([...originalList]);
    setSelectedMetrics([...reportData]);
  };

  async function setTheCheckedValues(perfList, isInitial, reportRes) {
    if (isInitial) {
      getCustomMetrics(perfList, false, reportRes);
    }
    setTheCustomCheckedVal([...perfList]);
    setPerformanceMetrics([...perfList]);
  }

  const checkOrUnCheckAttr = (attr, index, isPopular = false) => {
    let popularMetricChecked = [];
    let ind = index;
    if (isPopular) {
      performanceMetrics.filter(li => li?.sys_id === attr?.sys_id)[0].isChecked = !attr.isChecked;
      let resulted = performanceMetrics.filter(li => li?.sys_id === attr?.sys_id)[0].isChecked;
      if(!resulted) {
        performanceMetrics.filter(li => li?.sys_id === attr?.sys_id)[0].primary_kpi = false;
        performanceMetrics.filter(li => li?.sys_id === attr?.sys_id)[0].secondary_kpi = false;
      }
      ind = performanceMetrics.findIndex(li => li?.sys_id === attr?.sys_id)
      popularMetricChecked = performanceMetrics.filter(li => li?.sys_id === attr?.sys_id);
    } else {
      performanceMetrics[index].isChecked = !attr.isChecked;
      if(!performanceMetrics[index].isChecked) {
        performanceMetrics[index].primary_kpi = false;
        performanceMetrics[index].secondary_kpi = false;
      } 
    }
    setTheMessages({});
    if (performanceMetrics[ind].isChecked || (isPopular && popularMetricChecked[0]?.isChecked)) {
      let metric = !isPopular ? performanceMetrics[ind] : popularMetricChecked[0];
      const checkedAttr = {
        sys_id: metric.sys_id,
        metric_name: metric.KPI_Metric ? metric.KPI_Metric : metric?.name,
        planned_value: metric.planned_value ? metric.planned_value : '',
        primary_kpi: metric.primary_kpi ? metric.primary_kpi : false,
        secondary_kpi: metric.secondary_kpi ? metric.secondary_kpi : false,
        data_type: metric?.data_type,
        type: metric?.type,
        can_be_secondary: metric?.can_be_secondary,
        can_be_primary: metric?.can_be_primary,
      };
      setSelectedMetrics([...selectedMetris, checkedAttr]);
    } else {
      let filteredVal = !isPopular
        ? selectedMetris?.filter(metric => metric.sys_id !== performanceMetrics[index]?.sys_id)
        : selectedMetris?.filter(metric => metric.sys_id !== popularMetricChecked[0]?.sys_id);
      setSelectedMetrics([...filteredVal]);
    }
  };

  const handleClick = async (e, isSaveDraft) => {
    try {
      let selectedMetrics = [];
      selectedMetris?.forEach((metric, index) => {
        if(metric?.planned_value && metric?.planned_value !== '') {
          selectedMetrics.push({
            sys_id: metric.sys_id,
            plannedValue: metric?.planned_value ? metric?.planned_value.toString() : '',
            isPrimaryKpi: metric?.primary_kpi,
            isSecondaryKpi: metric?.secondary_kpi,
            order: index + 1,
          });
        } else {
          selectedMetrics.push({
            sys_id: metric.sys_id,
            isPrimaryKpi: metric?.primary_kpi,
            isSecondaryKpi: metric?.secondary_kpi,
            order: index + 1,
          });
        }

      });
      const payload = {
        metrics: selectedMetrics,
        currency: selectedCurLabel?.label,
        reportName: user?.reportName,
      };
      const reportResponse = await ReportsService.updateReportDetails(
        userAccessToken,
        username,
        payload,
        reportId, 
        isSaveDraft
      );
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
        kpiList: performanceMetrics,
      }));

      const reportData = reportResponse?.data?.data;
      if (reportData && !isSaveDraft) {
        setActiveStep(activeStep + 1);
      }
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  };


  const handleOnSelectCurrency = (selectedOption, item) => {
    if (item) {
      setTheMessages({});
    }
    setSelecedCurrency(selectedOption);
    setCurrencyLabel(item);
  };

  const handleBackClick = () => {
    setIsBackClicked(true);
    setShowCancelModal(true);
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };

  const RadioButtonCellPrimary = ({ rowData, dataKey, onChange, ...props }) => {
    return (
      <Cell {...props}>
        <Radio
          key={`${rowData?.sys_id}primary`}
          value={rowData[dataKey]}
          onChange={() => onChange(rowData, dataKey)}
          checked={rowData[dataKey]}
          disabled={rowData?.type === 'custom' || !rowData?.can_be_primary}
        />
      </Cell>
    );
  };

  const RadioButtonCellSecondary = ({ rowData, dataKey, onChange, ...props }) => {
    return (
      <Cell {...props}>
        <Radio
          key={`${rowData?.sys_id}primary`}
          value={rowData[dataKey]}
          onChange={() => onChange(rowData, dataKey)}
          checked={rowData[dataKey]}
          disabled={rowData?.type === 'custom' || !rowData?.can_be_secondary}
        />
      </Cell>
    );
  };

  const EditableCell = ({ rowData, dataKey, onChange, onClick, onKeyPress, onPaste, ...props }) => {
    const editing = rowData.status === 'EDIT';
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <div className="input-change">
            <input
              type={rowData?.data_type === 'NUMBER' ? 'text' : 'number'}
              className="rs-input"
              min="0.01"
              step="0.01"
              defaultValue={rowData[dataKey]}
              onChange={event => {
                onChange && onChange(rowData.sys_id, dataKey, event);
              }}
              onKeyPress={event => onKeyPress(event, rowData)}
              onPaste={event => onPaste(event, rowData)}
            />
            <Button
              appearance="link"
              onClick={() => {
                onClick(rowData.sys_id);
              }}
            >
              {editing ? <SaveIcon /> : <EditIcon />}
            </Button>
          </div>
        ) : (
          <div className="table-content-edit-container">
            <span className="table-content-edit-span input-data">
              {rowData[dataKey]
                ? rowData[dataKey]
                : rowData?.data_type === 'CURRENCY'
                ? t('define.matric.enterCurrency')
                : rowData?.data_type === 'PERCENTAGE'
                ? t('define.matric.enterPrecentage')
                : t('define.matric.enterValue')}
            </span>
            <Button
              appearance="link"
              onClick={() => {
                onClick(rowData.sys_id);
              }}
            >
              {editing ? <SaveIcon /> : <EditIcon />}
            </Button>
          </div>
        )}
      </Cell>
    );
  };

  const handleChange = (id, key, e) => {
    const value = e.target.value;
    const nextData = Object.assign([], selectedMetris);
    nextData.find(item => item.sys_id === id)[key] = value;
  };

  const formatText = (e, rowData) => {
    if (rowData?.data_type === 'NUMBER') {
      const NUMBER_DOT_COMMA = /^[\d]*$/;
      if (!NUMBER_DOT_COMMA.test(e.key) || e?.code === 'Minus') {
        e.preventDefault();
      }
    } else if (e?.code === 'Minus') {
      e.preventDefault();
    }
  };

  const preventPasteNegative = e => {
    const clipboardData = e?.clipboardData || window.clipboardData;
    const pastedData = parseFloat(clipboardData?.getData('text'));

    if (pastedData && pastedData < 0) {
      e.preventDefault();
    }
  };

  const handleEditState = id => {
    setSearchKeyword('');
    const nextData = Object.assign([], selectedMetris);
    const activeItem = nextData.find(item => item.sys_id === id);
    activeItem.status = activeItem?.status ? null : 'EDIT';
    originalList.find(data => data.sys_id === activeItem?.sys_id)['planned_value'] =
      activeItem.planned_value;
    setPerformanceMetrics([...originalList]);
    setOriginalList([...originalList]);
    setSelectedMetrics(nextData);
  };

  const handlePrimaryChange = (rowData, key) => {
    setSearchKeyword('');
    const nextData = Object.assign([], selectedMetris);
    nextData.forEach(metric => (metric[key] = false));
    originalList.forEach(metric => (metric[key] = false));
    if (nextData.length === 1 && key === 'secondary_kpi') {
      return;
    } else if (key === 'primary_kpi' && rowData.secondary_kpi) {
      nextData.find(item => item.sys_id === rowData.sys_id)['primary_kpi'] = true;
      nextData.find(item => item.sys_id === rowData.sys_id)['secondary_kpi'] = false;
      originalList.find(item => item.sys_id === rowData.sys_id)['primary_kpi'] = true;
      originalList.find(item => item.sys_id === rowData.sys_id)['secondary_kpi'] = false;
    } else if (key === 'secondary_kpi' && rowData.primary_kpi) {
      nextData.find(item => item.sys_id === rowData.sys_id)['primary_kpi'] = false;
      nextData.find(item => item.sys_id === rowData.sys_id)['secondary_kpi'] = true;
      originalList.find(item => item.sys_id === rowData.sys_id)['primary_kpi'] = false;
      originalList.find(item => item.sys_id === rowData.sys_id)['secondary_kpi'] = true;
    } else {
      nextData.find(item => item.sys_id === rowData.sys_id)[key] = true;
      originalList.find(item => item.sys_id === rowData.sys_id)[key] = true;
    }
    setSelectedMetrics(nextData);
    setPerformanceMetrics([...originalList]);
    setOriginalList([...originalList]);
  };

  const handleOpenSliderModal = (val, isAdded) => {
    if (isAdded) {
      setIsCustomMetricAdded(true);
      getCustomMetrics([...performanceMetrics], true, existingData);
    }
    setOpenSliderModal(!openSliderModal);
  };

  function Row({ children, onDrag, id, rowData, ...rest }) {
    const ref = React.useRef(null);

    const [{ canDrop, isOver }, drop] = useDrop({
      accept: ItemTypes.ROW,
      collect: monitor => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
      drop(item, monitor) {
        onDrag && onDrag(item.sys_id, rowData.sys_id);
      },
    });

    const [{ isDragging }, drag] = useDrag({
      item: { sys_id: rowData.sys_id },
      type: ItemTypes.ROW,
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    });
    const isActive = canDrop && isOver;

    drag(drop(ref));

    const styles = {
      cursor: 'grab',
      opacity: isDragging ? 0.5 : 1,
      background: isActive ? '#ddd' : null,
      width: '100%',
      height: '100%',
      borderTop: isActive ? '2px solid #2589f5' : null,
    };

    return (
      <div ref={ref} style={styles}>
        {children}
      </div>
    );
  }

  function sort(source, sourceId, targetId) {
    const nextData = source.filter(item => item.sys_id !== sourceId);
    const dragItem = source.find(item => item.sys_id === sourceId);
    const index = nextData.findIndex(item => item.sys_id === targetId);

    nextData.splice(index, 0, dragItem);
    return nextData;
  }

  const handleDragRow = (sourceId, targetId) => {
    setSelectedMetrics(sort(selectedMetris, sourceId, targetId));
  };

  const onDelete = async attr => {
    setDelAttr(attr);
    setShowDeleteAttributeModal(true);
  };

  const handleOnCancel = e => {
    e.preventDefault();
    setDelAttr({});
    setShowDeleteAttributeModal(false);
  };

  const onDeleteContinue = async () => {
    try {
      const delRes = await ReportsService.deleteCustomMetric(
        userAccessToken,
        username,
        delAttr.sys_id
      );
      const updatedRes = delRes?.data?.data;
      if (updatedRes) {
        const updatedList = performanceMetrics.filter(res => res?.sys_id !== delAttr?.sys_id);
        const removeDeletedOne = selectedMetris?.filter(res => res?.sys_id !== delAttr?.sys_id);
        setSelectedMetrics([...removeDeletedOne]);
        setPerformanceMetrics([...updatedList]);
        setOriginalList([...updatedList]);
        setDelAttr({});
        setShowDeleteAttributeModal(false);
      }
    } catch (error) {
      setShowDeleteAttributeModal(false);
      setDelAttr({});
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  };

  const handleCancelClick = e => {
    e.preventDefault();
    setShowCancelModal(true);
    setIsBackClicked(false);
  };

  const handleOnCloseCancelModal = () => {
    setShowCancelModal(false);
    setIsBackClicked(false);
  };

  const onEditCustomMetric = attr => {
    setCurrentEditCusMetric(attr);
    setOpenSliderModal(!openSliderModal);
  };
  const onNewCusMetrics = () => {
    setCurrentEditCusMetric({});
    removeSearchedKey();
    setOpenSliderModal(!openSliderModal);
  };

  const onContinue = e => {
    e.preventDefault();
    setShowCancelModal(false);
    setUser(prevUser => ({
      ...user,
      isSaveDraft: false,
    }));
    if (isBackClicked) {
      setActiveStep(activeStep - 1);
    } else {
      if (user?.isFirstTimeCreation) {
        handleDeleteReport({ reportId: reportId });
      } else {
        history.push('/reports');
      }
    }
  };

  async function handleDeleteReport(payload) {
    try {
      const deleteRes = await ReportsService.deleteReport(userAccessToken, username, payload);
      const delResponse = deleteRes.data?.data;
      if (delResponse.message === 'Successfully Updated') {
        setUser(prevUser => ({
          ...user,
          isFirstTimeCreation: false,
        }));
      }
      history.push('/reports');
    } catch (error) {
      setUser(prevUser => ({
        ...user,
        isFirstTimeCreation: false,
      }));
      history.push('/reports');
    }
  }

  const onSaveDraft = e => {
    e.preventDefault();
    handleClick('', true);
    if (isBackClicked) {
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
      }));
      setActiveStep(activeStep - 1);
    } else {
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
      }));
      history.push('/reports');
    }
    setShowCancelModal(false);
  };

  const onCancelReq = () => {
    setIsBackClicked(false);
    setShowCancelModal(false);
  };
  const handleSearchOnChange = searchText => {
    const textedVal = searchText?.target?.value?.trim();
    setSearchKeyword(textedVal);
    let resulted = originalList.filter(item => {
      return (
        item?.KPI_Metric?.toLowerCase()?.includes(textedVal?.toLowerCase()) ||
        item?.name?.toLowerCase()?.includes(textedVal?.toLowerCase())
      );
    });
    let popularResulted = originalPopularList?.filter(item => {
      return (
        item?.KPI_Metric?.toLowerCase()?.includes(textedVal?.toLowerCase()) ||
        item?.name?.toLowerCase()?.includes(textedVal?.toLowerCase())
      );
    });
    setPerformanceMetrics([...resulted]);
    setPopularMetricsList([...popularResulted]);
  };

  const removeSearchedKey = () => {
    setSearchKeyword('');
    setPerformanceMetrics([...originalList]);
    setPopularMetricsList([...originalPopularList]);
    setExpand({});
  };

  const setTheMessages = message => {
    if (message?.message) {
      setToaster(true);
      setMessage([]);
      setMessage(message);
      clearToaster();
    } else {
      setToaster(false);
      setMessage([]);
    }
  };

  let clearToaster = () => {
    setTimeout(() => {
      setToaster(false);
    }, 7000);
  };

  const checkPrimaryKPIExist = () => {
    return selectedMetris.some(li => li.primary_kpi);
  };

  let getCategoriesSeparation = arr => {
    let subCategories = [];
    let finalResult = [];

    arr.filter(li => subCategories.push(li.KPI_subcategory));
    const uniqueSubCategories = [...new Set(subCategories)];
    uniqueSubCategories.forEach((cat, i) => {
      if (cat === 'Custom Metrics') {
        finalResult.unshift({ id: i + 1, subCategory: cat, expand: false });
      } else {
        finalResult.push({ id: i + 1, subCategory: cat, expand: false });
      }
    });
    finalResult.unshift({
      id: uniqueSubCategories?.length +1,
      subCategory: 'Popular Metrics',
      expand: false,
    });
    return finalResult;
  };

  const handleExpand = (sub, result) => {
    if(expand?.id) {
      sub.expand = expand?.id === sub?.id ? expand?.expand : sub.expand;
    }
    sub.expand = sub.expand === true ? false: true;
    result?.forEach(res => res.expand = false);
    if(sub?.subCategory === 'Custom Metrics') {
      setIsCustomMetricAdded(false);
    }
    result.find(res => res.id === sub.id).expand = sub?.expand;
    setExpand(sub);
    setPerfMetricsWithSub(result)
  };

  return (
    <div className="report-metrics">
      <div className={toaster ? 'toasterTop' : ''}>
        <CommonToaster message={message} toaster={toaster}></CommonToaster>
      </div>
      <div className="exit">
        <button className="step-cancel" onClick={handleCancelClick}>
          {t('report.client.reporting.exit')}
        </button>
      </div>
      <div className="heading-container">
        <div className="metric-header">
          <div className="align-header">
            <h3 className="header-width">{t('define.report.metric.header')}</h3>
            <div className="heading-container edit-label" onClick={() => onNewCusMetrics()}>
              <EditIcon />
              <p>{t('define.matric.btn.customMetric')}</p>
            </div>
          </div>
          <p>{t('define.report.metric.discription')}</p>
        </div>
      </div>
      <SelectedCampaignsContainer selectedCampaigns={existingData}></SelectedCampaignsContainer>
      <div className="metric-table-container">
        <DndProvider backend={HTML5Backend}>
          <div>
            <Table
              height={295}
              data={selectedMetris}
              rowKey="sys_id"
              headerHeight={50}
              virtualized
              bordered
              cellBordered
              className={'pointer-cursor'}
              locale={{ emptyMessage: t('define.matric.table.emptyMgs') }}
              renderRow={(children, rowData) => {
                return rowData ? (
                  <Row
                    key={rowData.sys_id}
                    rowData={rowData}
                    id={rowData.sys_id}
                    onDrag={handleDragRow}
                  >
                    {children}
                  </Row>
                ) : (
                  children
                );
              }}
            >
              <Column width={getWidth(35)}>
                <HeaderCell></HeaderCell>
                <Cell dataKey="sys_id">
                  <KebabIcon />
                  <KebabIcon />
                </Cell>
              </Column>
              <Column width={getWidth(6)}>
                <HeaderCell>
                  {t('define.matric.table.metricName')}
                  <Whisper
                    placement="bottom"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>{t('define.report.metric.metric-name.tooltip')}</Tooltip>}
                  >
                    <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                  </Whisper>
                </HeaderCell>
                <Cell dataKey="metric_name"></Cell>
              </Column>

              <Column width={getWidth(3.7)}>
                <HeaderCell>
                  <span className="planned_val">
                    {t('define.matric.table.plannedValue')}
                    <Whisper
                      placement="bottom"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={<Tooltip>{t('define.report.metric.plannedvalue.tooltip')}</Tooltip>}
                    >
                      <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                    </Whisper>
                  </span>
                  <span className="input-cur">
                    <InputPicker
                      value={selectedCurrency}
                      onSelect={(e, item) => handleOnSelectCurrency(e, item)}
                      data={currencyData}
                      style={{ width: 158 }}
                      placeholder={t('report.client.reporting.currency')}
                    />
                  </span>
                  <span className="imp-icon cur-val">*</span>
                </HeaderCell>
                <EditableCell
                  dataKey="planned_value"
                  onChange={handleChange}
                  onClick={handleEditState}
                  onKeyPress={formatText}
                  onPaste={preventPasteNegative}
                />
              </Column>

              <Column width={getWidth(8)}>
                <HeaderCell>
                  {t('define.matric.table.primaryKpi')} <span className="imp-icon">*</span>
                  <Whisper
                    placement="bottom"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>{t('define.report.metric.primaryKpi.tooltip')}</Tooltip>}
                  >
                    <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                  </Whisper>
                </HeaderCell>
                <RadioButtonCellPrimary dataKey="primary_kpi" onChange={handlePrimaryChange} />
              </Column>

              <Column width={getWidth(7)}>
                <HeaderCell>
                  {t('define.matric.table.secondaryKpi')}
                  <Whisper
                    placement="left"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>{t('define.report.metric.secondaryKpi.tooltip')}</Tooltip>}
                  >
                    <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                  </Whisper>
                </HeaderCell>
                <RadioButtonCellSecondary dataKey="secondary_kpi" onChange={handlePrimaryChange} />
              </Column>
            </Table>
          </div>
        </DndProvider>
      </div>
      <div className="available-metrics-container">
        <div className='metric-section'>
          <h3 className='header-metrics'>{t('define.metric.availableMetric')}</h3>
          <div className="search-bar">
          <div className="c-search-bar c-search-bar--input">
            <i className="eva eva-search-outline search-icon"></i>
            <input
              className="c-search-input"
              type="text"
              placeholder={t('custom.metric.search')}
              value={searchKeyword}
              name="search"
              autoComplete="off"
              onChange={handleSearchOnChange}
            />
            <i
              className="eva eva-close-outline clear-icon search-icon"
              onClick={() => removeSearchedKey()}
            ></i>
          </div>
        </div>
        </div>

        {/* <div className="metrics-grid">
          <div>
            <h6>Custom metrics</h6>
            <p>No metrics created</p>
          </div>
          <div className="checkbox-container">
            <h6>Popular metrics</h6>
            {CheckboxColumn('Amount Spent')}
            {CheckboxColumn('Impressions')}
            {CheckboxColumn('Reach')}
            {CheckboxColumn('Results')}
            {CheckboxColumn('Cost per result')}
            {CheckboxColumn('Delivery')}
            {CheckboxColumn('Frequency')}
            {CheckboxColumn('Link clicks')}
            {CheckboxColumn('CPC (Cost per link click)')}
            {CheckboxColumn('CPM (Cost per 1000 impressions)')}
            {CheckboxColumn('CTR (All)')}
          </div>
          <div className="checkbox-container">
            <h6>Performance</h6>
            {performanceMetrics.map((attr, index) => (
              <span>
                <Checkbox
                  checked={attr.isChecked}
                  key={Math.random().toString()}
                  onChange={() => checkOrUnCheckAttr(attr, index)}
                />
                <label title={attr.KPI_Metric}>{attr.KPI_Metric}</label>
              </span>
            ))}
          </div>
        </div> */}
        {!performanceMetrics?.length && searchKeyword && (
          <div>{t('define.stepper.table.noDataFound')}</div>
        )}

        {performanceMetrics?.length || popularMetricsList?.length ? (
          <div className="kpi-attr">
            {/* <div>
              <div className="metric-header">{t('define.metric.customMetric')}</div>
              {performanceMetrics.map((attr, index) => {
                if (attr?.type === 'custom') {
                  return (
                    <span className="checkbox-name align-items">
                      <span className="custom-align">
                        <Checkbox
                          checked={attr.isChecked}
                          key={`${index}custom`}
                          onChange={() => checkOrUnCheckAttr(attr, index)}
                        />
                        <label className="space-label label-name" title={attr.KPI_Metric}>
                          {attr.KPI_Metric}
                        </label>
                        <span>
                          <EditIcon className="edit" onClick={() => onEditCustomMetric(attr)} />
                          <DeleteIcon className="icon-size" onClick={() => onDelete(attr)} />
                        </span>
                      </span>
                    </span>
                  );
                }
              })}
            </div>
            <div className="metric-header">{t('define.metric.popularMetric')}</div>
            {popularMetricsList?.map((attr, index) => {
              return (
                <span className="checkbox-name align-items">
                  <Checkbox
                    checked={attr.isChecked}
                    key={`${index}popular`}
                    onChange={() => checkOrUnCheckAttr(attr, index, true)}
                  />
                  {attr?.KPI_Metric && <label title={attr.KPI_Metric}>{attr.KPI_Metric}</label>}
                </span>
              );
            })}
            <div className="metric-header">{t('define.metric.volumeMetric')}</div>
            {performanceMetrics.map((attr, index) => {
              if (attr?.KPI_type === 'Volume') {
                return (
                  <span className="checkbox-name align-items">
                    <Checkbox
                      checked={attr.isChecked}
                      key={`${index}volume`}
                      onChange={() => checkOrUnCheckAttr(attr, index)}
                    />
                    <label title={attr.KPI_Metric}>{attr.KPI_Metric}</label>
                  </span>
                );
              }
            })}
            <div className="metric-header">{t('define.metric.effectivenessMetric')}</div>
            {performanceMetrics.map((attr, index) => {
              if (attr?.KPI_type === 'Effectiveness') {
                return (
                  <span className="checkbox-name align-items">
                    <Checkbox
                      checked={attr.isChecked}
                      key={`${index}effective`}
                      onChange={() => checkOrUnCheckAttr(attr, index)}
                    />
                    <label title={attr.KPI_Metric}>{attr.KPI_Metric}</label>
                  </span>
                );
              }
            })}
            <div className="metric-header">{t('define.metric.efficiencyMetric')}</div>
            {performanceMetrics.map((attr, index) => {
              if (attr?.KPI_type === 'Efficiency') {
                return (
                  <span className="checkbox-name align-items">
                    <Checkbox
                      checked={attr.isChecked}
                      key={`${index}effieciency`}
                      onChange={() => checkOrUnCheckAttr(attr, index)}
                    />
                    <label title={attr.KPI_Metric}>{attr.KPI_Metric}</label>
                  </span>
                );
              }
            })} */}
            <div>
              {getCategoriesSeparation(performanceMetrics)?.map(sub => {
                return (
                  <div className="acc-align">
                    <Accordion expanded={expand?.expand && sub.id === expand.id ? true: false} disabled={false}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        onClick={() => {
                          handleExpand(sub, getCategoriesSeparation(performanceMetrics));
                        }}
                      >
                        <>
                          {sub.subCategory} {isCustomMetricAdded && sub?.subCategory === 'Custom Metrics' && <span className='add-icon'> </span>}
                          {expand?.expand && sub.id === expand.id ? true: false}
                        </>
                      </AccordionSummary>
                      {sub.subCategory === 'Popular Metrics' && popularMetricsList?.length ?  (
                        <AccordionDetails>
                          {popularMetricsList?.map((attr, index) => {
                            return (
                              <span className="checkbox-name align-items acc-change">
                                <Checkbox
                                  checked={attr.isChecked}
                                  key={`${index}popular`}
                                  onChange={() => checkOrUnCheckAttr(attr, index, true)}
                                />
                                {attr?.KPI_Metric && (
                                  <label title={attr.KPI_Metric}>{attr.KPI_Metric}</label>
                                )}
                              </span>
                            );
                          })}
                        </AccordionDetails>
                      ): sub.subCategory === 'Popular Metrics' && !popularMetricsList?.length ? <AccordionDetails><span className='no-data'>{t('report.no.data.found')}</span></AccordionDetails>: null}

                      {sub.subCategory !== 'Popular Metrics' && (
                        <AccordionDetails>
                          {performanceMetrics.map((attr, index) => {
                            if (attr?.KPI_subcategory === sub?.subCategory && attr?.type !== 'custom') {
                              return (
                                <span className="checkbox-name align-items acc-change">
                                  <Checkbox
                                    checked={attr.isChecked}
                                    key={`${index}effieciency`}
                                    onChange={() => checkOrUnCheckAttr(attr, index)}
                                  />
                                  <label title={attr.KPI_Metric}>{attr.KPI_Metric}</label>
                                </span>
                              );
                            }
                            if (attr?.type === 'custom' && attr?.KPI_subcategory === sub?.subCategory) {
                              return (
                                <span className="checkbox-name align-items acc-change">
                                  <span className="custom-align">
                                    <Checkbox
                                      checked={attr.isChecked}
                                      key={`${index}custom`}
                                      onChange={() => checkOrUnCheckAttr(attr, index)}
                                    />
                                    <label className="space-label label-name" title={attr.KPI_Metric}>
                                      {attr.KPI_Metric}
                                    </label>
                                    <span>
                                      <EditIcon className="edit" onClick={() => onEditCustomMetric(attr)} />
                                      <DeleteIcon className="icon-size" onClick={() => onDelete(attr)} />
                                    </span>
                                  </span>
                                </span>
                              );
                            }
                          })}
                        </AccordionDetails>
                      )}
                    </Accordion>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="btn-steps">
        <button
          className="step-back"
          disabled={activeStep === 0}
          label="Back"
          onClick={handleBackClick}
        >
          {t('define.report.stepper.button.back')}
        </button>

        <span
          className="step-next"
          data-tip={
            !selectedMetris?.length || !selectedCurrency || !checkPrimaryKPIExist()
              ? t('define.metric.next.btn.tooltip')
              : ''
          }
          data-for="tool-tip3"
        >
          <button
            className="step-next"
            onClick={handleClick}
            label="Next"
            disabled={!selectedMetris?.length || !selectedCurrency || !checkPrimaryKPIExist()}
          >
            {t('define.report.stepper.button.next')}
          </button>
        </span>
        <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip3" place="left" />
      </div>
      {openSliderModal && (
        <RightModal openSliderModal={openSliderModal}>
          <CustomMetric
            handleOpenSliderModal={handleOpenSliderModal}
            performanceMetrics={sysMetrics}
            stepperData={stepperData}
            edirMetrics={currentEditCusMetric}
            existResponse={existingData}
          />
        </RightModal>
      )}

      <div className="report-delete back-popup">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showCancelModal}
          onRequestClose={handleOnCloseCancelModal}
          heading={
            !isBackClicked ? t('define.stepper.cancel.heading') : t('define.stepper.back.heading')
          }
          ariaHideApp={false}
          appElement={document.getElementById('app')}
        >
          <p className="fqa-model-showanswer--message message-font">
            {!isBackClicked
              ? t('define.stepper.cancel.request')
              : t('define.stepper.back.subHeading')}
          </p>
          <p></p>
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={!isBackClicked ? t('define.stepper.save') : t('define.stepper.back.save')}
              handleClick={onSaveDraft}
            />
            <ActionLink
              anchor={true}
              value={
                !isBackClicked
                  ? t('define.stepper.cancel.continue')
                  : t('define.stepper.back.continue')
              }
              handleClick={onContinue}
            />
            <Button className="fqa-model-pa--actions-confirm delete-button" onClick={onCancelReq}>
              {t('define.stepper.cancel')}
            </Button>
          </div>
        </ModalWindow>
      </div>
      <div className="attr-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showDeleteAttributeModal}
          onRequestClose={handleOnCancel}
          heading={t('define.metric.header.deleteMetric')}
          ariaHideApp={false}
          appElement={document.getElementById('app')}
        >
          <p className="fqa-model-showanswer--message message-font">{t('report.custom.metric.delete')}</p>
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={t('reportTable.campaign.delete.cancel')}
              handleClick={handleOnCancel}
            />
            <Button className="fqa-model-pa--actions-confirm delete-button" onClick={onDeleteContinue}>
              {t('reportTable.campaign.delete')}
            </Button>
          </div>
        </ModalWindow>
      </div>
    </div>
  );
};

export default ReportMetrics;
